var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isPastShift } from '../../../../backend/utils/shiftStateUtils';
import { useMissionsTranslation, useShiftStorage } from '../../../../ui/hooks';
import { useMissionLocationStorage } from '../../../../ui/hooks/useStorage';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { handleErrorSnackbar, showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useCallback } from 'react';
import { useShiftWizardSteps } from './useShiftWizardSteps';
export const useEditShift = ({ missionId, shiftId, shiftData }) => {
    const { t } = useMissionsTranslation();
    const shiftStorage = useShiftStorage();
    const missionLocationStorage = useMissionLocationStorage();
    const editShiftWizardActionContext = { isEdit: true };
    if (shiftData) {
        editShiftWizardActionContext.isPastShift = isPastShift(shiftData);
    }
    const { shiftWizardSteps } = useShiftWizardSteps(shiftData === null || shiftData === void 0 ? void 0 : shiftData.positions, editShiftWizardActionContext);
    if (!shiftId) {
        throw new Error(t('errors.shiftIdRequired'));
    }
    if (!missionId) {
        throw new Error(t('errors.missionIdRequired'));
    }
    const handleSubmit = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        let missionLocationId;
        if (data.addNewLocation) {
            missionLocationId = (yield missionLocationStorage.post({
                action: 'create',
                data: Object.assign(Object.assign({}, data.addNewLocation), { status: 'active' }),
            })).id;
            data.checkInAddress = 'existingAddress';
            delete data.addNewLocation;
        }
        const checkInAddressId = (_a = data.checkInAddressId) !== null && _a !== void 0 ? _a : missionLocationId;
        if (!checkInAddressId) {
            return handleErrorSnackbar({
                message: 'Check-in address is not defined',
            });
        }
        if (data.additionalPositions) {
            data.positions.push(...data.additionalPositions);
            delete data.additionalPositions;
        }
        return shiftStorage
            .post({
            action: 'partial-update',
            id: shiftId,
            data: Object.assign(Object.assign({ missionId }, data), { checkInAddressId }),
        })
            .then(() => {
            showInfoSnackbar({
                message: t('shifts.updated'),
                autoHideDuration: 2000,
            });
        })
            .catch(handleErrorDialog);
    }), [t, shiftStorage, missionId, shiftId, missionLocationStorage]);
    const wizardConfig = {
        steps: shiftWizardSteps,
        title: t('shifts.editShift'),
        data: shiftData,
        submitButtonLabel: t('common.saveChanges'),
        closeWizardContent: t('wizard.closeWizardContentEdit'),
        onSubmit: handleSubmit,
    };
    return {
        wizardConfig,
    };
};
